import { render } from "./person-delete.vue?vue&type=template&id=023bb658"
import script from "./person-delete.vue?vue&type=script&lang=js"
export * from "./person-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__